module.exports = __webpack_public_path__ + "static/media/planetwin365.3dbd29bc.png";